import React from 'react';
import { Skeleton } from '../index';

import {
  Wrapper,
  Row,
} from './styles';

const GhostTicket = () => (
  <Wrapper>
    <Row height={15}>
      <Skeleton />
    </Row>
    <Row height={50}>
      <Skeleton />
    </Row>
  </Wrapper> 
);

export default GhostTicket;
